import { useAuth } from "@/app/AuthContext";
import AuthScreen from "@/app/AuthScreen";
import AppShell from "@/app/AppShell";
import WordmarkLogo from "@/components/wynn/WordmarkLogo";

function Splash() {
  return (
    <div className="min-h-screen bg-[#070608] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 animate-pulse">
        <WordmarkLogo height={34} />
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/40 font-body">
          opening
        </span>
      </div>
    </div>
  );
}

export default function WynnApp() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <AuthScreen />;
  return <AppShell />;
}
